import React from 'react';

import NolList from '../../../modules/nol/list/NolList';

const NolListPage = () => <NolList />;

export default NolListPage;
